import { Col, Row, Statistic, Button, Card, Space, Modal, Divider } from 'antd'
import { PlusOutlined, DownloadOutlined, EditOutlined } from '@ant-design/icons'
import { useState, useEffect, useRef } from 'react'
import AddProcurement from './AddProcurement'
import BasicProcurementListTable from './BasicProcurementListTable'
import ProcurementBasicForm from './ProcurementBasicForm'
import useGetProcurementList from '../hooks/useGetProcurementListByParams'
import useProcurementTypeContext from '../hooks/useProcurementTypeContext'
import useSelectColumsOperate from '../hooks/useSelectColumsOperate'
import AuthComponent from '../../../components/AuthComponent'
import { procurementTypeFundStatus } from '../config'
import '../../../style/statistic.less'

export default function ProcurementContent({ showAdd, setShowAdd }) {
  const [modal, contextHolder] = Modal.useModal()
  const [purchaseStatus, setPurchaseStatus] = useState('')
  const { procurementType, isOrder, procurementTypeText, baseKey } =
    useProcurementTypeContext()
  // const [showAdd, setShowAdd] = useState(false)
  const { pageData, getListBasice, loading, totalData, getAmountData } =
    useGetProcurementList()
  const [storeId, setStoreCode] = useState(null)
  const requestParams = useRef(null)
  const getNewFormData = para => {
    setStoreCode(para.storeId)
    setPurchaseStatus(para.purchaseStatus)
    requestParams.current = para
    return Promise.all([getAmountData(para), getListBasice({ formData: para })])
  }
  const freshStatisticAndNowPage = () => {
    return Promise.all([getAmountData(requestParams.current), getListBasice()])
  }
  const {
    exportList,
    setSelectedRows,
    selectedRowKeys,
    confirmDiscard,
    openConfirmBatchSetPayStatusModal
  } = useSelectColumsOperate({
    modal,
    pageData,
    freshList: freshStatisticAndNowPage,
    type: procurementType
  })
  useEffect(() => {
    setShowAdd(false)
  }, [procurementType])

  const operateBtns = (
    <Space>
      <AuthComponent authKey={baseKey + 'create'}>
        <Button
          icon={<PlusOutlined />}
          onClick={() => setShowAdd(true)}
          type='primary'>
          新建{procurementTypeText}
        </Button>
      </AuthComponent>
      <AuthComponent authKey={baseKey + 'mark-pay-status'}>
        <Button
          icon={<EditOutlined />}
          type='primary'
          onClick={openConfirmBatchSetPayStatusModal}>
          标记{!isOrder ? '退款' : '付款'}状态
        </Button>
      </AuthComponent>
      {purchaseStatus != 0 && (
        <AuthComponent authKey={baseKey + 'bills-discard'}>
          <Button type='primary' onClick={confirmDiscard}>
            单据作废
          </Button>
        </AuthComponent>
      )}
      <AuthComponent authKey={baseKey + 'export'}>
        <Button type='primary' icon={<DownloadOutlined />} onClick={exportList}>
          导出
        </Button>
      </AuthComponent>
    </Space>
  )

  return (
    <>
      <div style={showAdd ? { height: 0, width: 0, overflow: 'hidden' } : {}}>
        <Card>
          <ProcurementBasicForm
            queryNewData={getNewFormData}></ProcurementBasicForm>
        </Card>
        <Card style={{ marginTop: 20 }}>
          {operateBtns}
          <Space
            className='total-box'
            style={{ marginTop: 20 }}
            split={<Divider type='vertical' />}>
            {isOrder ? (
              <Statistic
                title='总结算金额(元)'
                value={totalData.enterTotalMoney}
              />
            ) : (
              <Statistic
                title='总退款金额（元）'
                value={totalData.quitTotalMoney}
              />
            )}
            {procurementTypeFundStatus[procurementType].map(item => (
              <Statistic
                title={item.key + '(元)'}
                key={item.countKey}
                value={totalData[item.countKey]}
              />
            ))}
          </Space>
          <BasicProcurementListTable
            loading={loading}
            selectedRowKeys={selectedRowKeys}
            setSelectedRows={setSelectedRows}
            pageData={pageData}
            confirmCancel={confirmDiscard}
            modal={modal}
            getList={getListBasice}
          />
        </Card>
      </div>
      {showAdd && (
        <AddProcurement
          storeId={storeId}
          freshList={freshStatisticAndNowPage}
          hide={() => setShowAdd(false)}
        />
      )}
      {contextHolder}
    </>
  )
}
